import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { rgba } from 'polished';
import { red } from '~/theseus/styles/core';

const boxStyles = (color: string) => css`
  outline: 0;
  border: 1px solid ${color};
  box-shadow: 0 0 4px ${rgba(color, 0.5)};
`;

interface Props {
  isError: boolean;
}

const borderStyles = ({ isError }: Props) => {
  if (isError) {
    return boxStyles(red);
  }

  return css`
    &:focus,
    &:focus-within,
    &:invalid {
      ${boxStyles('#2685f7')}
    }
  `;
};

const Input = styled.input<Props>`
  padding: 6px;
  font-size: 13px;
  border-radius: 2px;
  border: 1px solid #00000033;

  &::placeholder,
  &:placeholder,
  &:-moz-placeholder {
    color: #0000004c;
  }

  &:active {
    outline: 0;
  }

  ${borderStyles}
`;

export default Input;
